import React, { Component } from "react";
import { Spinner, Alert, Button } from "react-bootstrap";

/**
 * WidgetLoader - Spinner + error + retry wrapper for widget loading states.
 * Pattern from DynamicPage.js
 */
export default class WidgetLoader extends Component {
  render() {
    const { loading, error, onRetry, children, minHeight } = this.props;

    if (loading) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: minHeight || "200px" }}
        >
          <Spinner animation="border" variant="primary" size="sm" />
          <span className="ms-2 text-muted" style={{ fontSize: "0.875rem" }}>
            Loading widget...
          </span>
        </div>
      );
    }

    if (error) {
      return (
        <Alert variant="danger" className="m-2">
          <div className="d-flex align-items-center justify-content-between">
            <span style={{ fontSize: "0.875rem" }}>
              <i className="bi bi-exclamation-circle me-2"></i>
              {error}
            </span>
            {onRetry && (
              <Button variant="outline-danger" size="sm" onClick={onRetry}>
                <i className="bi bi-arrow-clockwise me-1"></i>Retry
              </Button>
            )}
          </div>
        </Alert>
      );
    }

    return children || null;
  }
}
